var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoDolyame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 16,
    viewBox: "0 0 102 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3906 0.800049H15.988V12.984H18.3906V0.800049Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.228 1.48182H10.8253V13.6655H13.228V1.48182Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06533 2.24296H5.66266V14.429H8.06533V2.24296Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90267 3.01255H0.5L0.500009 15.2H2.90268L2.90267 3.01255Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8492 7.29151L77.9806 2.99022H75.7189V12.9492H78.0803V6.59518L81.6122 10.3597H82.0487L85.5199 6.59518V12.9492H87.8812V2.99022H85.6196L81.8492 7.29151Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1312 2.99022L93.2784 9.46319V2.99022H90.917V12.9492H93.0804L98.9332 6.47622V12.9492H101.295V2.99022H99.1312Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63 6.63435C63 8.21995 63.8671 9.469 65.1981 9.9927L62.7023 12.9492H65.5926L67.8629 10.2596H70.3197V12.9492H72.681V2.99022H66.6693C64.4278 2.99022 63 4.52359 63 6.63435ZM70.3211 5.18366V8.12856H67.1071C66.0348 8.12856 65.4597 7.53088 65.4597 6.65466C65.4597 5.77844 66.0551 5.18076 67.1071 5.18076L70.3211 5.18366Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0269 4.98201C51.8824 8.40709 51.1599 10.6179 49.7451 10.6179H49.391V13.0087L49.7682 13.029C52.605 13.1871 54.173 10.6977 54.4302 5.26055H58.1616V12.9492H60.5186V2.99022H52.1064L52.0269 4.98201Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.138 2.85107C39.9443 2.85107 37.6465 5.06192 37.6465 7.96911C37.6465 10.9764 40.1466 13.1089 43.138 13.1089C46.2537 13.1089 48.6743 10.8574 48.6743 7.96911C48.6743 5.08078 46.2537 2.85107 43.138 2.85107ZM43.138 10.7182C41.333 10.7182 40.1032 9.54311 40.1032 7.96911C40.1032 6.35594 41.3345 5.2128 43.138 5.2128C44.9415 5.2128 46.2133 6.40817 46.2133 7.96911C46.2133 9.53005 44.9242 10.7182 43.138 10.7182Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1421 3.009H26.808L26.7285 5.0008C26.61 7.87027 25.8614 10.599 24.4466 10.6382L23.792 10.6585V15.2002L26.1736 15.1954V12.9506H34.447V15.1954H36.8488V10.6382H35.1421V3.009ZM32.7808 10.6382H27.7416C28.5942 9.34417 29.0508 7.47133 29.1303 5.28078H32.7808V10.6382Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDolyame);
export default __webpack_public_path__ + "static/media/LogoDolyame.f3b20ea489acbcbd40f089326f8fb427.svg";
export { ForwardRef as ReactComponent };